import { render, staticRenderFns } from "./Transcript.vue?vue&type=template&id=1b9d2861"
import script from "./Transcript.vue?vue&type=script&lang=js"
export * from "./Transcript.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports